import Form from './Converter'
import './App.css';

function App() {
  return (
    <div>
    <Form />
  </div>
  );
}

export default App;


